
  import { Vue, Component } from "vue-property-decorator";
  import { Utils, WebAgent } from "../helper";
  import { UserService } from "../services";
  import { getModule } from "vuex-module-decorators";
  import { Auth } from "@/store/modules/AuthModule";
  import store from "@/store";

  const AuthModule = getModule(Auth, store);

  @Component({
    name: "Authorize"
  })
  export default class Authorize extends Vue {
    publicPath: string = process.env.BASE_URL as string;

    async mounted() {
      if (this.$route.query.code !== undefined) {
        this.$mainLoader.show();
        var response = await UserService.GetAuthorizeCode(
          (this.$route.query as any).code
        );

        if (response.status === 200) {
          await AuthModule.checkUserAuthentication();
          this.$mainLoader.hide();
          this.gotToPage();
        } else {
          this.$modal.show("Failed to authorized your account", "error");
          this.$mainLoader.hide();
          this.gotToPage();
        }
      }
    }

    gotToPage() {
      setTimeout(function () {
        if (window.opener) {
          window.opener.location.reload();
          window.close();
        } else {
          var url = localStorage.getItem("last_url");
          if (url.indexOf("authorize") >= 0) {
            url = this.publicPath;
          }
          if (WebAgent.IsInternetExplore()) {
            window.history.pushState("", "", url);
            window.location.reload(true);
          } else {
            window.location.replace(url);
          }
        }
      }, 3000);
    }
    getImagePath(path: string) {
      return `${this.publicPath}${path}`;
    }

    get greeting() {
      return Utils.Greeting(false);
    }
  }
